export default "__VITE_ASSET__56f6f403__"